<template>
  <div class="reset languageSelector">
    <div class="languageDropdown__container" data-testid="container_userLanguageSelector" @click="openSelector">
      <div class="languageDropdown__activeLanguage">
        <flag-img
          :value="value"
        />
        <sword-button-wuk
          class="menu-btn t3 -t_semi-bold hidden-mobile"
          theme="text-heavy"
          size="medium"
          :text="value.toUpperCase()"
          data-testid="text_selectedLanguage"
        />
      </div>
    </div>

    <div v-show="isSelectionOpen"
         class="languageSelector__backdrop"
         data-testid="container_languagesDropdownBackdrop"
         @click="closeSelector"
    >
    </div>
    <transition name="fade">
      <nav v-show="isSelectionOpen" class="languageDropdownOptions__nav" data-testid="container_languagesDropdown" :class="`--${openDirection}`">
        <language-selector-list
          :title="$t('select_a_language')"
          :options="options"
          :selected="value"
          @selected="(option)=> selectLanguage(option)"
        />
      </nav>
    </transition>
  </div>
</template>

<script>
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue';

import LanguageSelectorList from './LanguageSelectorList.vue';
import FlagImg from './LanguageFlag.vue';

export default {
  name: 'LanguageSelector',

  components: {
    FlagImg,
    LanguageSelectorList,
    SwordButtonWuk,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    openDirection: {
      type: String,
      validator: prop => [
        'up',
        'down',
      ].includes(prop),
      default: 'down',
    },
    compact: {
      type: Boolean,
      default: false,
    },
    hideArrowOnMobile: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['change'],

  data() {
    return {
      isSelectionOpen: false,
    };
  },

  methods: {
    openSelector() {
      this.isSelectionOpen = true;
    },
    closeSelector() {
      this.isSelectionOpen = false;
    },
    selectLanguage(value) {
      this.$emit('change', value);
      this.isSelectionOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.languageSelector {
  @media screen and (min-width: $tablet-size) {
    position: relative;
  }

  &__backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 999;
    opacity: 0.3;
    background-color: getColor($greys, 1);

    @media screen and (min-width: $tablet-size) {
      background-color: transparent;
    }
  }
}

.languageDropdown {
  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75em;
    cursor: pointer;
  }

  &__activeLanguage {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .25rem;
  }
}

.languageDropdownOptions {
  &__nav {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 999999;
    min-width: 13.75em;

    border-radius: 16px 16px 0px 0px;
    background-color: #fff;
    box-shadow: 0px 2px 6px rgba(29, 56, 97, 0.25);
    padding: map-get($sh-spacers-wuk, 1) map-get($sh-spacers-wuk, 0);

    @media screen and (min-width: $tablet-size) {
      position: absolute;
      width: max-content;
      padding: map-get($sh-spacers-wuk, 0);
      border-radius: 1rem;
      right: 0;
      left: auto;

      &.--down {
        margin-top: map-get($sh-spacers-wuk, 1);
        margin-bottom: 0;
        bottom: auto;
      }

      &.--up {
        margin-top: 0;
        margin-bottom: map-get($sh-spacers-wuk, 2);
        bottom: map-get($sh-spacers-wuk, 2);
      }
    }
  }
}
</style>
